export default {
    language: "中文",
    bgColor: {
        black: "经典黑色",
        blue: "蓝色风格"
    },
    Menu: {
        home: "首页",
        taskManage: "任务管理",
        deviceManage: "设备管理",
        groupManage: "分组业务",
        fileMenu: "文件菜单",
        userManage: "用户管理",
    },
    Home: {
        logout: "退出登录",
        summary: "公司资源汇总",
        deviceTotal: "设备总数",
        taskTotal: "任务总数",
        configFileTotal: "配置文件总数",
        groupTotal: "分组总数",
        userTotal: "用户总数",
        quickApp: "快速应用通道",
        userCreate: "用户增加",
        deviceCreate: "设备增加",
        fileCreate: "文件增加",
        groupCreate: "创建分组",
        deviceMove: "设备移动",
        taskCreate: "创建任务",
        deviceState: "设备状态",
        inactiveDevice: "01.不活跃的设备总数",
        freeDevice: "02.空闲的设备总数",
        pendingDevice: "03.等待任务的设备总数",
        firmwareState: "固件状态",
        firmwaretotal: "总计",
        firmwareToday: "今天",
        firmwareYtday: "昨天",
        searchMore: "查看更多",
        noMore: "已经到底啦",
        taskStateTitle: "任务批次状态",
        searchDetail: "查看明细",
        taskNum: "序号",
        taskName: "任务名称",
        taskType: "任务分类",
        taskCode: "任务编号",
        taskState: "任务状态",
        completeTotal: "完成设备数|总数",
        taskCreateTime: "任务创建时间",
        taskCreatePerson: "任务发起人",
        baseInfo: "基本信息",
        changePass: "修改密码",
        oldPass: "原密码",
        newPass: "新密码",
        confirmPass: "确认密码",
        oldPassInput: "请输入原密码",
        newPassInput: "请输入新密码",
        confirmPassInput: "请再次输入新密码",           
    },
    Query: {
        inputQuery: "输入查询",
        queryTaskHolder: "任务名",
        queryTaskType: "任务类型",
        queryDeviceHolder: "设备名/型号/IMEI/系列/文件",
        queryGroupHolder: "分组名",
        queryFileHolder: "文件名",
        queryFileSource: "来源",
        queryFileType: "文件类型",        
        queryUserHolder: "用户账号/邮箱",
        selectPlaceHolder: "全部",
        company: "公司",
        group: "分组",
        createTime: "创建时间",
        startTime: "开始日期",
        endTime: "结束日期",
        queryBtn: "查询",
        resetBtn: "重置",
        noticePlaceHolder: "消息标题",
        noticePublish: "已发布",
        noticeUnpublish: "未发布",
        expandSearch: "更多搜索",
        collapseSearch: "收起搜索",
        queryMoveDeviceHolder: "设备名/型号/IMEI",
    },
    Button: {
        export: "导出",
        create: "创建",
        batchCreate: "批量创建",
        delete: "删除",
        submit: "提交",
        back: "返回",
        edit: "编辑",
        move: "移动",
        createGroup: "创建分组",
        confirm: "确定",
        cancel: "取消",
        publish: "发布",
        next: "下一步",
        backUpload: "重新返回上传",
        finish: "完成",
        removeButton: "从分组中移除",
        addButton: "移动到目标组",
        save: "保存",
        view: "查看",
        selectFile: "选取文件",
        upload: "上传",
        stop: "终止",
        changePass: "修改密码"
    },
    Export: {
        dataTitle: "数据列表",
        task: "任务",
        device: "设备",
        group: "分组",
        file: "文件",
        user: "用户"
    },    
    Table: {
        operation: "操作"
    },
    TaskManage: {
        id: "ID",
        taskName: "任务名称",
        taskState: "任务状态",
        taskType: "任务类型",
        imei: "IMEI",
        mode: "Model",
        deviceSeries: "设备系列",
        company: "所属公司",
        group: "所属分组",
        originVer: "原始版本",
        targetVer: "目标版本",
        connectTime: "连接时间",
        createPerson: "创建人",
        createTime: "创建时间",
        updateFirmware: "固件升级",
        updateConfig: "参数配置",
        receiveConfig: "参数上传",
        receiveLog: "接收内部日志",
        sentTLS: "发送TLS文件",
        taskPending: "待处理",
        taskCancel: "任务取消",
        taskFail: "任务失败",
        taskError: "任务成功但有错误",
        taskAssign: "运行中",
        taskDownLoadFile: "已下载文件，尚未执行",
        taskExecute: "任务已执行",
        taskPartFail: "部分终端任务失败",
        selectFile: "选择文件",
        targetFile: "目标文件",
        autoMatch: "系统自动匹配",
        manuallySelectFile: "手动选择文件"
    },
    DeviceManage: {
        id: "ID",
        deviceName: "设备名称",
        imei: "IMEI",
        mode: "型号",
        deviceSeries: "设备系列",
        sn: "S/N",
        configFile: "配置文件",
        firmwareVer: "固件版本",
        funcitonVer: "功能版本",        
        deviceState: "设备状态",
        connectState: "连接状态",
        updateTime: "更新于",
        createTime: "创建时间",
        targetFile: "目标文件",
        company: "所属公司",
        group: "所属分组",   
        securityFile: "安全文件版本",
        ip: "域名/IP",
        port: "端口号",
        cntFOTAfrequency: "连接FOTA频率(分钟)",
        cntFOTAfunciton: "连接FOTA manage功能",
        alarmClock: "闹钟设置",
        status_initial: "初始状态",
        status_inactive: "不活跃",
        status_free: "空闲",
        status_pending: "等待",
        status_working: "工作中",
        min: "分钟",
        bestVer: "最佳版本",
        task: "任务",
        fotaConnectParam: "FOTA连接参数",
        settings: "配置",
        onFOTA: "开启",
        offFOTA: "关闭",
        notSupport: "不支持",
        downloadTemplate: "下载模板",
        uploadFile: "上传文件",
        downloadImportTemplate: "下载创建设备模板",
        uploadExcelFile: "上传Excel文件",
        onlySupportXlsXlsx: "仅支持xlsx格式",
        createTemplate: "批量创建设备模板",
        uploarFail:"创建失败",
        tipFileLarge:"文件不能超过20M",
        tipSelectFile:"请选择文件",
        uploadSuccess:"创建设备成功",
        tip:"只能上传xlsx文件，且不超过20MB"
    },
    GroupManage: {
        id: "ID",
        groupName: "分组名",
        company: "所属公司",
        firmwareFile: "固件文件",
        configFile: "配置文件",
        createTime: "创建于", 
        deviceSeries: "设备系列",
        mode: "设备类型",
        deviceState: "设备状态",
        fmWareVerStart: "起始固件版本",
        fmWareVerEnd: "结束固件版本",
        imei: "IMEI",
        deviceName: "设备名称",
        removeDevice: "从分组中移除",
        addDevice: "移动到目标组",
        selectCompany: "请选择公司",
        selectGroup: "请选择分组",
        selectTargetCompany: "请选择目标公司",
        selectTargetGroup: "请选择目标组",
    },
    FileMenu: {
        id: "ID",
        describe: "来源",
        file: "文件",
        type: "类型",
        createTime: "创建于",
        fileType: "文件类型",
        configFile: "配置文件",
        otaFile: "OTA文件",
        uploadTitle: "上传参数配置表",
        uploadTip: "文件后缀名必须为mop",
        inputUpload: "填写信息并上传文件",
        executeAdd: "执行添加",
        completeAdd: "完成添加",
        importable: "本次可导入文件数量",
        notImport: "本次不可导入文件数量",
        addSuccess: "添加成功",
        fromDevice: "来自设备",
        fromFile: "来自文件",
    },
    UserManage: {
        id: "ID",
        userName: "用户账号",
        userEmail: "邮箱",
        company: "公司名",
        createTime: "创建于",
        validUntil: "有效期至",
        enabled: "启用",
        userPass: "用户密码",
        contact: "联系人",
        phone: "手机号码",
        remark: "信息备注",
        taskPer: {
            manage: "任务管理",
            create: "创建任务",
            edit: "编辑任务",
            delete: "删除任务"            
        },
        devicePer: {
            manage: "设备管理",
            import: "批量导入",
            create: "增加设备",
            edit: "编辑设备",
            move: "移动设备",
            delete: "删除设备",
        },
        groupPer: {
            manage: "分组业务管理",
            create: "创建分组",
            edit: "编辑分组",
            move: "移动分组信息",
            delete: "删除分组",         
        },
        filePer: {
            manage: "文件菜单管理",
            create: "文件添加",
            edit: "文件编辑",
            delete: "文件删除"            
        },
        userPer: {
            manage: "用户管理",
            create: "增加用户",
            edit: "编辑用户信息",
            delete: "删除用户信息"            
        },
        noticePer: {
            manage: "消息管理",
            create: "新建消息",
            edit: "消息编辑",
            delete: "消息删除",
            view: "消息查看"            
        },
    },
    NoticeManage: {
        noticeCenter: "消息中心",
        receiveSetting: "接收设置",
        totalNotice: "全部消息",
        productNotice: "产品消息",
        securityNotice: "安全消息",
        seviceNotice: "服务消息",
        receiveTitle: "消息接收设置",
        settingMess: "建议您务必设置接收，防止消息遗漏造成损失",
        systemNotice: "系统消息",
        productUpNotice: "产品更新通知",
        firmwareUpNotice: "固件更新通知",
        fileUpNotice: "文件更新通知",
        functionUpNotice: "功能更新通知",
        securityUpNotice: "安全信息通知",
        seviceUpNotice: "服务消息通知",
        id: "ID",
        noticeTitle: "消息标题",
        updateTime: "修改时间",
        publisher: "发布人员",
        noticeType: "消息分类",
        noticeState: "消息状态",
        noticeColumn: "消息栏目",
        noticeReceiver: "接收对象",
        noticeContent: "消息内容",
        noticeWay: "提醒方式",
        noticePlatform: "站内信",
        noticeEmail: "邮件",
        createColumn: "添加栏目",
        columnName: "栏目名称",
        columnDescrip: "栏目描述"
    },
    Rules: {
        require: "必填项",
        IMEI: "请输入正确的IMEI",
        userName: "请输入长度3到20位的数字和字母",
        userPass: "请输入长度6到20位的数字、字母和特殊字符",
        userEmail: "请输入正确的邮箱地址",
        phone: "请输入正确的手机号码",
        sn: "请输入正确的S/N",
        name: "请输入长度2到20位的数字、字母和汉字",
        inconsistent: "两次输入密码不一致",
        firmwareVer: "请输入正确的固件版本",
        configFile: "请输入正确的配置文件",
    },
    Message: {
        reqError: "请联系管理员",
        tip: "提示",
        confirmDelete: "确定要删除吗？",
        delete: "删除成功",
        deleteFail: "删除失败",
        selectDeleteItem: "请先选中要删除的项目",
        success: "提交成功",
        select: "请选择",
        selectTime: "选择时间",
        confirmPublish: "确定要发布吗？",
        publish: "发布成功",
        selectPublishItem: "请先选中要发布的项目",
        edit: "修改成功",
        editFail: "修改失败",
        operate: "操作成功",
        operateFail: "操作失败",
        selectItem: "请先选中项目",
        confirmRemove: "确定从该分组移除？",
        confirmAddGroup: "确定移动到",
        selectDevice: "请勾选设备",
        selectTargetFile: "请选择目标文件",
        confirmCancel: "确定要终止吗？",
        cancel: "终止成功",
        loginAgain: "由于长时间未进行操作，请重新登录",
        fileError: "上传失败，请检查文件",
        noPermission: "无权限操作",
        reLogin: "切换语言需重新登录系统",
        cfmSendFOTAParam: "若FOTA连接参数错误修改将导致设备无法正常使用，确定要修改吗？",
        passwordMess: "原密码错误"
    },
    CreatePage: {
        baseInfo: "基础信息",
        filter: "筛选条件",
        baseInfoFilter: "基础信息筛选",
        taskDetail: "任务详情",
        paramSetting: "连接FOTA参数配置",
        createTask: "创建任务",
        editTask: "编辑任务",
        createDevice: "创建设备",
        editDevice: "编辑设备",
        createGroup: "创建分组",
        editGroup: "编辑分组",
        createFile: "创建文件",
        editFile: "编辑文件",
        createUser: "创建用户",
        editUser: "编辑用户",
        permission: "权限设置",
        backButton: "返回",
        createNotice: "创建消息",
        editNotice: "编辑消息",
        moveDevice: "设备移动"
    },
    LoginPage: {
        login: "登 录",
        account: "用户名",
        password: "密码",
        forgetPassword: "忘记密码?",
        policy: "我已阅并同意FOTA Manager",
        policyLink: "隐私政策",
        forgetPassTop: "忘记密码？请在下方输入您的注册账户以接收密码重置指令。密码将发送到绑定的邮箱。",
        forgetPassBtm: "忘记密码?",
        send: "发 送",
        loginSuccess: "登录成功",
        loginFail: "登录失败",
        sendSuccess: "发送成功",
        sendFail: "发送失败",                   
        invalidUser: "此用户不存在"
    },
    Policy: {
        title: "隐私保护服务政策说明",
        time: "2022-09-01",
        content1: "Meitrack（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的服务与/或产品时，我们可能会收集和使用您的相关信息。我们希望通过《Meitrack隐私政策》（“本隐私政策”）向您说明我们在您使用我们的服务与/或产品时如何收集、使用、保存这些信息，以及我们为您提供的访问、查询、更新、删除和保护这些信息的方式。",
        content2: "本政策将帮助您了解以下内容：",
        content3: "1、我们如何收集和使用您的个人信息",
        content4: "2、我们如何使用 Cookie 和同类技术",
        content5: "3、我们如何保护您的个人信息",
        content6: "4、您如何管理个人信息",
        content7: "5、未成年人信息的保护",
        content8: "6、通知和修订",
        content9: "7、如何联系我们",
        content10: "本隐私政策与您所使用的Meitrack FOTA Manager服务以及该服务所包括的各种业务功能（以下统称“我们的服务与/或产品”）息息相关，希望您在使用我们的服务与/或产品前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的服务与/或产品，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。",
        content11: "本政策仅适用于Meitrack FOTA Manager向您提供的各项产品和服务。如我们提供的某款产品有单独的隐私政策，或相应的用户服务协议当中存在特殊规定，则该产品的隐私政策将优先适用；该款产品隐私政策和用户协议未涵盖的内容，以本政策内容为准。"
    }

}